module.exports = __webpack_public_path__ + "ec581b8b0770e3e31157550dfe01c06e.png";